<template>

<div class="container-fluid px-0">
    <label v-if="props.label" for="client">Select Clients</label>
    <client-ac v-model="client"></client-ac>
    <ul class="list-group my-2" v-if="selected.length">
        <li class="list-group-item">
            <span
                v-for="row in selected"
                @click="removeItem(row.CustomerNumber)" 
                style="cursor: pointer;"
                class="badge badge-pill bg-secondary me-2 mb-2">
                <i class="fa fa-times"></i> {{ row.Company }}
            </span>
        </li>
        <!-- 
        <li v-for="row in selected" class="list-group-item px-0">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-8 my-auto">
                        <small>{{ row.Company }}</small>
                    </div>
                    <div class="col-4 text-end">
                        <button class="btn btn-sm btn-secondary" 
                            @click="removeItem(row.CustomerNumber)">
                            <i class="fa fa-close"></i>
                        </button>
                    </div>
                </div>
            </div>
        </li>
        -->
    </ul>
</div>

</template>

<script setup>

import { ref, watch } from "vue";
import ClientAc from "@/components/Clients/ClientAc.vue";
import { useClientStore } from "@/stores/ClientStore";

const props = defineProps({
  label: { type: String, default: "Select Clients" }
})

const clientStore = useClientStore();
const client = ref("");
const selected = ref([]);
const model = defineModel([]);

watch(() => {
    return client.value
}, async (nv, ov) => {
    if (nv)
    {
       addItem(nv); 
    }
});

watch(() => {
    return model.value
}, async (nv, ov) => {
    selected.value = [];
    model.value.forEach(async (custNum) => {
        let cm = await clientStore.getByCustomerNumber(custNum);
        selected.value = [... selected.value, cm];
    });
    
}, { immediate: true });

const addItem = async (custNum) =>
{

    if ((model.value || []).includes(custNum))
    {
        return;
    }

    model.value = [... (model.value || []), custNum];
    
}

const removeItem = (custNum) =>
{
    let tmp = [];
    (model.value || []).forEach((val) => {
        if (val != custNum)
        {
            tmp.push(val);
        }
    });

    model.value = tmp;
    
};

</script>